import type { MotionScale } from './types';

export const BRAVEMOVE_MOTION: MotionScale = {
  ease: {
    snap: 'cubic-bezier(.34,1.56,.64,1)',
    out: 'cubic-bezier(.4,0,.2,1)',
    inOut: 'cubic-bezier(.4,0,.6,1)',
  },
  dur: {
    tap: 120,
    quick: 200,
    page: 320,
    beat: 1200,
  },
};
